import type { FC } from 'react';
import React from 'react';

import type { BaseComponentProps } from '../../../../../types';
import { DataHook } from '../../../../../types';
import { Loader } from './common';
import { Content } from './Content';
import { Cover } from './Cover';
import styles from './DesktopResponsiveWidget.scss';

const DesktopResponsiveWidget: FC<BaseComponentProps> = ({ profilePage }) => {
  const { isSaving, isCoverRepositionMode } = profilePage;

  return (
    <div data-hook={DataHook.HorizontalWidget} className={styles.box}>
      {isSaving && <Loader />}
      <Cover />
      {!isCoverRepositionMode && <Content />}
    </div>
  );
};

export default DesktopResponsiveWidget;
